module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/f205eca6ce7c7dfe8649e7d1bbf8c20a.png";